import { grayColor } from "../../../lib/style";

const style = () => ({
  inputAdornmentIcon: {
    color: grayColor[6],
  },
});

export default style;
